<template>
  <div class="action-item-container">
    <div class="action-header">
      {{ heading }}
      <v-icon 
        class="action-close" 
        color="red"
        large
        @click="closeOptions">mdi-close</v-icon>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ActionContainer',
  props: {
    heading: {
      type: String,
      required: true
    }
  },
  methods: {
    closeOptions() {
      this.$emit('closeOptions');
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-item-container {
    overflow: visible !important;
    position: absolute;
    top: -40px;
    right: 60px;
    border: solid #cccccc 1px;
    margin: auto;
    background: white;
    z-index: 40;
    min-width: 200px;
    .action-header {
      color: white;
      background: #0f74bb;
      position: relative;
      font-size: 20px;
      padding-left: 16px;
      text-transform: capitalize;
      padding-top: 4px;
      padding-bottom: 4px;
    }
    .action-close {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
</style>